import { getAdvanced, normalizePageBuilderHtml } from '../../utils'

const configAggregator = (node) => {
    const mainEl = node.querySelector('[data-element="main"]')
    const raw = mainEl?.innerHTML || node.innerHTML || node.textContent || ''
    const { html, cssBlocks } = normalizePageBuilderHtml(raw)

    return {
        html,
        cssBlocks,
        ...getAdvanced(node)
    }
}

export default configAggregator
